import { InjectionToken } from "@angular/core";
import { ICloudQuickAccessMenuStateService } from "./i-cloud-quick-access-menu-state.service";

export const cloudQuickAccessMenuStateServiceInjectionToken: InjectionToken<ICloudQuickAccessMenuStateService> = new InjectionToken<ICloudQuickAccessMenuStateService>("digital-signage.user-dashboard.dashboard-web.CloudQuickAccessMenuStateService");
